<div class="flex h-full flex-col justify-center gap-2 px-4 py-3">
  <div class="flex items-center justify-between gap-3">
    <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide leading-tight">Tasa de cobranza</p>
    <span class="shrink-0 flex items-center justify-center w-9 h-9 rounded-xl bg-violet-100">
      <i class="pi pi-percentage text-violet-600 text-base"></i>
    </span>
  </div>
  <p class="text-3xl font-bold text-slate-900 leading-none tabular-nums">
    {{ data()?.rates?.collectionRate ?? 0 }}<span class="text-xl font-semibold text-slate-400">%</span>
  </p>
  <p class="text-xs text-slate-500 font-medium">
    Respecto al total facturado
  </p>
</div>
